import 'reflect-metadata';
import { Expose } from 'class-transformer';
import { IsNumber } from 'class-validator';
import { LengthValue } from './LengthValue'; // Adjust the import path as needed
import { ELengthValueType } from './ELengthValueType'; // Adjust the import path as needed

export class LengthValueCentimeter extends LengthValue {
    
    @Expose()
    @IsNumber()
    private _centimeter: number;

    constructor(value: number) {
        super(value);
        this._centimeter = value;
    }

    @Expose()
    get millimeter(): number {
        return Math.round(this._centimeter * 10);
    }

    @Expose()
    get centimeter(): number {
        return this._centimeter;
    }

    @Expose()
    get meter(): number {
        return this._centimeter / 100;
    }

    @Expose()
    get type(): ELengthValueType {
        return ELengthValueType.Centimeter;
    }

    static multiply(a: LengthValueCentimeter, b: number): LengthValueCentimeter {
        return new LengthValueCentimeter(a.centimeter * b);
    }

    static add(a: LengthValueCentimeter, b: LengthValueCentimeter): LengthValueCentimeter {
        return new LengthValueCentimeter(a.centimeter + b.centimeter);
    }

    static subtract(a: LengthValueCentimeter, b: LengthValueCentimeter): LengthValueCentimeter {
        return new LengthValueCentimeter(a.centimeter - b.centimeter);
    }
}
